export default [
  {
    path: "/transfers/new",
    name: "transfers-create",
    meta: {
      title: "Трансфер",
      authRequired: true,
    },
    component: () => import("@/modules/transfers/views/edit.vue"),
  },
];
